<div [fxLayout]="direction" [fxLayoutAlign]="(direction == 'row') ? 'start center' : 'center end'">
  <div class="ratings">
    @for (star of stars; track star; let i = $index) {
      <mat-icon class="mat-icon-xs" (click)="rate(i)">{{star}}</mat-icon>
    }
  </div>
  @if (showText) {
    <p class="ratings-count text-muted">{{ratingsCount}} {{'sale4you.label.ratings' | translate }}</p>
  }
</div>